import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-tools-icon',
  templateUrl: './tools-tools.component.html'
})
export class ToolsToolsComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
